import React, { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  Divider,
  Typography,
} from "@material-ui/core";
//componentes del sistema
import {
  palette,
  useStylesGlobal,
  msmSwalError,
  msmSwalExito,
} from "configurations/styles/theme";
import { useSelector } from "react-redux";
import { getRUCEmpresa, getSub } from "redux/actions/userActions";
import { clientPythonBackend } from "configurations/axios";
import { useStylesApp } from "hooks/useStyles";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import { subscriptionKey } from "configurations/constant";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const MassUploadCostumerBtn = ({ updateView }) => {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const tokenUser = useSelector((state) => state.user.tk);
  const [errors, setErrors] = useState({});
  const [file, setFile] = useState(null);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  var fileSaver = require("file-saver");

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };
  const uploadExcel = async () => {
    setOpenLoader(true);
    const formData = new FormData();
    formData.append("file", file);
    let rucEmpresa = tokenUser ? getRUCEmpresa(tokenUser) : "0";
    let idAsigancionEmpresaUsuario = Number(getSub(tokenUser));
    await clientPythonBackend
      .post(
        "/clients/upload/xlsx/" + rucEmpresa + "/" + idAsigancionEmpresaUsuario,
        formData,
        {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          msmSwalExito(
            "Clientes enviados para agregar exitosamente. En un momento le llegará el resultado del proceso a su correo"
          );
          setOpenLoader(false);
          handleClose();
          setFile(null);
        } else {
          msmSwalError("Error al enviar los clientes para agregar.");
          setOpenLoader(false);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          msmSwalError(
            exception.response.data == ""
              ? "El archivo no se encuentra en el formato requerido para la carga masiva de clientes. Revise que contenga las columnas requeridas e inténtelo de nuevo"
              : exception.response.data.detail
          );
          setOpenLoader(false);
        } else {
          msmSwalError(
            "Existen problemas en la red. Contáctese con el administrador del Sistema."
          );
        }
        setOpenLoader(false);
      });
  };

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <UploadRoundedIcon
          style={{ color: palette.primary.contrastText, paddingRight: "3%" }}
          fontSize="small"
        />{" "}
        Carga Masiva
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Carga Masiva de Clientes
        </DialogTitle>
        <DialogContent>
          <Fragment>
            <Grid container xs={12} justify="center" alignItems="center"></Grid>

            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              align="center"
            >
              <Grid container>
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    aling="center"
                    color="primary"
                    variant="subtitle2"
                  >
                    Los campos marcados con (
                    <font color={palette.error.main}> *</font>) son
                    obligatorios:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
              >
                <Grid item lg={2} xs={12}>
                  <Typography
                    aling="center"
                    color="primary"
                    variant="subtitle2"
                  >
                    Archivo en formato (.xlsx):
                    <font color={palette.error.main}> *</font>
                  </Typography>
                </Grid>
                <Grid item lg={2} xs={12}>
                  <input
                    type="file"
                    name="file"
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {errors.cufe ? (
                    <p className={classesApp.errorLetters}>{errors.cufe}</p>
                  ) : null}
                </Grid>
              </Grid>
              <br></br>
              <Grid>
                <Divider className={classes.divider} />
              </Grid>

              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={12} lg={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={uploadExcel}
                    className={classesGlobal.marginButton}
                  >
                    Cargar Archivo
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClose}
                    className={classesGlobal.marginButton}
                  >
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Backdrop className={classes.backdrop} open={openLoader}>
              <CircularProgress color="primary" />
            </Backdrop>
          </Fragment>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default MassUploadCostumerBtn;
